<script lang="ts" setup>
import VCard from '@components/card/VCard/VCard.vue';
import VLoader from '@components/loader/VLoader.vue';
import VFormPlainDataListbox from '@modules/forms/components/inputs/VFormPlainDataListbox/VFormPlainDataListbox.vue';
import { TRANSLATION_GROUPS_OF_MANAGERS_LIST } from '@modules/groups-of-managers/constants';
import { useGroupsOfManagersListQuery } from '@modules/groups-of-managers/queries';

const { data, isLoading } = useGroupsOfManagersListQuery();
</script>

<template>
  <VCard v-data-qa-auto-id="'GroupOfManagersPage'"
    :title="$getTranslation(TRANSLATION_GROUPS_OF_MANAGERS_LIST, 'HEADER')"
    type="form"
  >
    <VLoader
      :loading="isLoading"
      min-height="4rem"
      mode="overlay"
    >
      <VFormPlainDataListbox
        :label="$getTranslation(TRANSLATION_GROUPS_OF_MANAGERS_LIST, 'GROUP')"
        :data="data"
        readonly
      />
    </VLoader>
  </VCard>
</template>
